module.exports = __webpack_public_path__ + "static/img/floor2-ygsc.eec54cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor2-ygsc.png
// module id = Xmp8
// module chunks = 1